import React from 'react';

import PatientsList from '../component-list-patients';
import Suspense from '../../Common/components/Suspense-component';

export class PatientsContainer extends React.Component {
    render() {
        return (
            <Suspense>
                <PatientsList />
            </Suspense>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Patients/containers/container-list-patients.js